// eslint-disable-next-line import/prefer-default-export
export const columnList = [
  {
    key: 'name',
    name: 'name',
    required: true,
  },
  {
    key: 'job',
    name: 'job',
    required: false,
  },
  {
    key: 'organization_name',
    name: 'organization',
    required: false,
  },
  {
    key: 'mobile_number',
    name: 'phone number',
    required: true,
  },
  {
    key: 'home_number',
    name: 'home number',
    required: false,
  },
  {
    key: 'whatsapp_number',
    name: 'whatsapp number',
    required: false,
  },
  {
    key: 'line_id',
    name: 'line id',
    required: false,
  },
  {
    key: 'email_address_1',
    name: 'email address',
    required: true,
  },
  {
    key: 'email_address_2',
    name: 'alternative email address',
    required: false,
  },
  {
    key: 'address',
    name: 'detail address',
    required: true,
  },
  {
    key: 'postal_code',
    name: 'postal code',
    required: false,
  },
  {
    key: 'gender',
    name: 'gender',
    required: true,
  },
  {
    key: 'birth_date',
    name: 'birth date',
    required: true,
  },
  {
    key: 'income_per_month',
    name: 'income per month',
    required: false,
  },
  {
    key: 'education_institutions',
    name: 'education institution',
    required: false,
  },
  {
    key: 'expertises',
    name: 'expertise',
    required: false,
  },
  {
    key: 'past_job_titles',
    name: 'past job title',
    required: false,
  },
  {
    key: 'related_organization',
    name: 'related organization',
    required: false,
  },
  {
    key: 'hobbies',
    name: 'hobbies',
    required: false,
  },
  {
    key: 'favorites',
    name: 'favorites',
    required: false,
  },
  {
    key: 'ig_username',
    name: 'instagram',
    required: false,
  },
  {
    key: 'fb_username',
    name: 'facebook',
    required: false,
  },
  {
    key: 'linkedin_username',
    name: 'linkedin',
    required: false,
  },
  {
    key: 'twt_username',
    name: 'twitter',
    required: false,
  },
];

export const educationTypes = [
  {
    id: 1,
    name: 'Primary',
    value: 1,
  },
  {
    id: 2,
    name: 'Secondary',
    value: 2,
  },
  {
    id: 3,
    name: 'Bachelor',
    value: 3,
  },
  {
    id: 4,
    name: 'Master',
    value: 4,
  },
  {
    id: 5,
    name: 'Doctorate',
    value: 5,
  },
];

export const relationShipStatus = [
  {
    id: 1,
    name: 'Single',
    value: false,
  },
  {
    id: 2,
    name: 'Married',
    value: true,
  },
];

export const parentalStatus = [
  {
    id: 1,
    name: 'Has Children',
    value: true,
  },
  {
    id: 2,
    name: 'No Children',
    value: false,
  },
];

export const incomePerMonths = [
  {
    id: 1,
    name: '0 - 5 mln',
    value: 1,
  },
  {
    id: 2,
    name: '5.5 - 15 mln',
    value: 2,
  },
  {
    id: 3,
    name: '15.5 - 25 mln',
    value: 3,
  },
  {
    id: 4,
    name: '25.5 - 50 mln',
    value: 4,
  },
  {
    id: 5,
    name: '50.5 - 100 mln',
    value: 5,
  },
];
